/**
 * UUID v4
 * from https://gist.github.com/jed/982883
 */
export function generateUUID(placeholder) {
  return placeholder ? // eslint-disable-next-line  no-bitwise
  (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : "".concat(1e7, "-", 1e3, "-", 4e3, "-", 8e3, "-", 1e11).replace(/[018]/g, generateUUID);
}
var COMMA_SEPARATED_KEY_VALUE = /([\w-]+)\s*=\s*([^;]+)/g;
/**
 * Returns the value of the key with the given name
 * If there are multiple values with the same key, returns the first one
 */

export function findCommaSeparatedValue(rawString, name) {
  COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;

  while (true) {
    var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);

    if (match) {
      if (match[1] === name) {
        return match[2];
      }
    } else {
      break;
    }
  }
}
/**
 * Returns a map of all the values with the given key
 * If there are multiple values with the same key, returns all the values
 */

export function findAllCommaSeparatedValues(rawString) {
  var result = new Map();
  COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;

  while (true) {
    var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);

    if (match) {
      var key = match[1];
      var value = match[2];

      if (result.has(key)) {
        result.get(key).push(value);
      } else {
        result.set(key, [value]);
      }
    } else {
      break;
    }
  }

  return result;
}
/**
 * Returns a map of the values with the given key
 * ⚠️ If there are multiple values with the same key, returns the LAST one
 *
 * @deprecated use `findAllCommaSeparatedValues()` instead
 */

export function findCommaSeparatedValues(rawString) {
  var result = new Map();
  COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;

  while (true) {
    var match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);

    if (match) {
      result.set(match[1], match[2]);
    } else {
      break;
    }
  }

  return result;
}
export function safeTruncate(candidate, length) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var lastChar = candidate.charCodeAt(length - 1);
  var isLastCharSurrogatePair = lastChar >= 0xd800 && lastChar <= 0xdbff;
  var correctedLength = isLastCharSurrogatePair ? length + 1 : length;

  if (candidate.length <= correctedLength) {
    return candidate;
  }

  return "".concat(candidate.slice(0, correctedLength)).concat(suffix);
}